import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-12 gap-6">
          <div>
            <p className="text-foreground-400 text-sm font-medium uppercase tracking-wider mb-2">Shop by Category</p>
            <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950 italic">
              Find Your Style
            </h2>
          </div>
          <p className="text-foreground-600 text-sm max-w-md leading-relaxed">
            Explore our comprehensive product categories, each with detailed comparison spreadsheets to help you make the smartest buying decisions.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {categories.map((cat, index) => (
            <a
              key={cat.imageUrl}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-lg bg-background-100 transition-all duration-300 group-hover:scale-[1.02]">
                <div className="relative h-52 md:h-56 overflow-hidden">
                  <img
                    src={cat.imageUrl}
                    alt={`${cat.name} category - PandabuySpreadsheet`}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    title={`${cat.name} - PandabuySpreadsheet Product Comparison`}
                    loading={index < 6 ? 'eager' : 'lazy'}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                </div>

                <div className="absolute top-4 left-4">
                  <span className="inline-block px-3 py-1 rounded-full bg-accent-400/90 text-background-50 text-xs font-medium">
                    {cat.name}
                  </span>
                </div>

                <div className="p-4">
                  <span className="block text-foreground-900 font-medium text-sm mb-1">{cat.name}</span>
                  <p className="text-foreground-500 text-xs leading-relaxed">{cat.description}</p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}